<template lang="pug">
  v-container(fluid)
    v-row(justify="center")
      v-col(cols="12" align="center")
        p.display-1.font-weight-black Can’t be with us in person? 
        p.display-1.font-weight-black We invite you to worship with us online each Sunday at 11AM.
        p.display-1.font-weight-black Or
        TheLink.display-2(:link="'https://www.youtube.com/channel/UCPd1Uyo-ATz_O07DRL8jY0g/featured'" :text="'VISIT OUR YOUTUBE PAGE'")
    v-row(justify="center")
      v-col(cols="12" align="center")
        v-card.pa-3(dark color="primary" shaped width="100%" height="450"  )
          .display-1.my-3 Sunday, 
            span(style="color: #D9AB23; text-decoration: underline") {{thisSunday}}
            |  Live Service
          v-img( src="../../assets/img/WelcomeToCORUCC.jpg" width="100%" height='64%' 'max-width'="460")
    v-container.info( fluid )
      v-row
        v-col(cols="12")
          .display-1 Previous Weeks Service
      v-row()
        v-col(v-for="(service, i) in services" :key="i" cols="12" md="6" align="center" )
          v-card.primary.darken-3.pa-3( dark shaped width="100%" height="100%" 'max-width'="500"   )
            v-card-title {{service.date}}
              iframe(width='100%' height='215' 'max-width'="460px"  :src="service.url" frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',allowfullscreen loading="lazy")
      //- v-btn( @click="putTest" ) Put
             
</template>

<script>
import axios from 'axios';
import TheLink from '../../components/contact/link';
import { getSunday } from '../../plugins/getDays';
export default {
  created() {
    // const data = require('../../assets/jsonFiles/pre-services.json');
    // console.log(data);
    // this.services = data;
    axios
      .get('/data/pre-services.json')
      .then(res => {
        console.log('created -> res', res);
        this.services = res.data.data;
      })
      .catch(err => console.log(err));
  },
  data() {
    return {
      services: []
    };
  },
  components: {
    TheLink
  },
  computed: {
    thisSunday() {
      return getSunday();
    },
    lastSunday() {
      return getSunday();
    }
  },
  methods: {
    putTest() {
      let hold = {
        date: 'Feb 99, 2020',
        url: 'https://www.youtube.com/embed/0101010101'
      };
      axios
        .post('http://localhost:3000/data', hold)
        .then(res => console.log(res))
        .catch(err => console.log(err));
    }
  }
};
</script>

<style lang="stylus" scoped>
.v-application
  font-family 'montserrat', 'arial', 'sans-serif' !important

  .display-2, .display-1
    font-family 'montserrat', 'arial', 'sans-serif' !important

  .pageTitles
    font-family Cardo, 'san-serif' !important

  .body-1, .body-2, .title
    font-family 'montserrat', 'arial', 'sans-serif' !important
</style>
